<template>
    <div class="row">
        <div class="col-lg-4 machine-selector-result-box-image-wrapper">
          <img :src="product.image">
        </div>
        <div class="col-lg-8 machine-selector-result-box-specs-wrapper">
          <h3>{{product.productName}}</h3>
          <p>{{product.machineType}}</p>
          <div class="col-lg-10 machine-selector-result-box-specs-table">
              <div class="row" v-for="valueSet in product.values" :key="valueSet.name">
                <div :class="machineDescription(valueSet.name)">{{valueSet.description}}</div>
                <div :class="machineValue(valueSet.name)">
                  <span v-html="splitValues(valueSet.value)"></span> {{valueSet.unit}}
                </div>
            </div>
          </div>
        </div>
    </div>
    <div class="col-12">
      <a class="cta-button" :href="product.detailUri">{{product.cta}}</a>
    </div>
</template>

<script>
export default {
  name: "Result",
  props: {
    product:{
      type:Object,
      required:true
    }
  },
  methods: {
    splitValues(values){
      if ( typeof values === 'string'){
          const val = values.split(',');
          return val.join('<br />');
      }
      return values;
      // const val = values.split(',');
      //   return val.join('<br />')
    },
    machineDescription(name){
      return 'col-9 machine-spec '+ name
    },
    machineValue(name){
      return 'col-3 machine-value '+ name
    }

  },
  created() {
    console.log('result object:',this.product);
  }
}
</script>

